import { createFileRoute } from '@tanstack/react-router'

import type { Email } from '@/api/gen'
import { accountEmailVerifyResendCreate } from '@/api/gen'
import { RootRoute } from '@/pages/auth/route-entries/verify-email'

export const Route = createFileRoute('/_auth/login/verify-email/')({
  component: RootRoute,
  loaderDeps: ({ search }) => {
    return { search }
  },
  loader: async ({ deps: { search } }) => {
    let status: 'success' | 'error' = 'success'

    try {
      await accountEmailVerifyResendCreate(search as Email)
    } catch (error) {
      status = 'error'

      console.error('Error resending email verification:', error)
    }

    return {
      status,
    }
  },
})
